module.exports = __webpack_public_path__ + "static/media/日历7@2x.c10861a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_145/img/日历7@2x.png
// module id = 1380
// module chunks = 0